import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { LogUtils } from "abweb/utils/log/LogUtils";
/**
 * Machine object to control column visibility.
 * You can create an instance of this class and pass it as a prop to the DataGrid if you need this support.
 */

import { Callback1Arg } from "abweb/utils/callback/Callback1Arg";
export class ColumnVisibilityMachine {
  constructor() {
    _defineProperty(this, "columnVisibilityChangeListeners", new Callback1Arg());
  }
  /**
   * Hides the indicated leaf.
   * @param {DataGridColumn} column
   */
  hideColumn(column) {
    if (this.dataGrid == null) {
      ColumnVisibilityMachine.LOG.warn("dataGrid not set");
    }
    if (this.isColumnFrozen(column)) {
      // Cannot hide frozen columns
      return;
    }
    this.dataGrid.hideColumn(column);
    this.columnVisibilityChangeListeners.callAll(column);
  }

  /**
   * Shows the indicated column.
   * @param {DataGridColumn} column
   */
  showColumn(column) {
    if (this.dataGrid == null) {
      ColumnVisibilityMachine.LOG.warn("dataGrid not set");
    }
    this.dataGrid.showColumn(column);
    this.columnVisibilityChangeListeners.callAll(column);
  }
  isColumnFrozen(column) {
    if (this.dataGrid == null) {
      ColumnVisibilityMachine.LOG.warn("dataGrid not set");
      return false;
    }
    return this.dataGrid.isColumnFrozen(column);
  }

  /**
   * Shows dialog to allow user to show/hide columns.
   */
  showColumnVisibilityDlg() {
    if (this.dataGrid == null) {
      ColumnVisibilityMachine.LOG.warn("dataGrid not set");
    }
    this.dataGrid.showColumnVisibilityDlg();
  }

  /**
   * Returns array of visible leaf columns.
   * @returns {DataGridColumn[]}
   */
  get visibleLeafColumns() {
    return this.dataGrid.visibleLeafColumns;
  }

  /**
   * Adds a listener to be called whenever the visibility of a column has changed.
   * @param listener
   * @return IUnsubscriber which can be used to removed the listener.
   * Alternatively, you can call removeColumnVisibilityChangedListener() with the same listener value to remove the listener.
   */
  addColumnVisibilityChangedListener(listener) {
    return this.columnVisibilityChangeListeners.addCallback(listener);
  }

  /**
   * Removes a listener added in a call to addColumnVisibilityChangedListener().
   * @param listener
   */
  removeColumnVisibilityChangedListener(listener) {
    this.columnVisibilityChangeListeners.removeCallback(listener);
  }
}
_defineProperty(ColumnVisibilityMachine, "LOG", LogUtils.getLogger(__filename));
//# sourceMappingURL=ColumnVisibilityMachine.js.map
